import { FA_USER_TYPE, ROLE } from "../routes/roles";
import { LoginUserDetails } from "../util/Utils";

const navigationFaUserAndFaAdmin = (navigate: any) => {
  if (LoginUserDetails.getUserDetails().userType === FA_USER_TYPE.CI) {
    if (LoginUserDetails.getUserDetails().attendance === "Yes") {
      navigate("/student-attendance");
    }
    if (LoginUserDetails.getUserDetails().certificate === "Yes") {
      navigate("/certificate-booking-printing");
    }
  } else if (
    LoginUserDetails.getUserDetails().userType === FA_USER_TYPE.TELE_CALLER
  ) {
    navigate("/student-lead-management");
  } else if (
    LoginUserDetails.getUserDetails().loginType === ROLE.HO_ADMIN ||
    LoginUserDetails.getUserDetails().loginType === ROLE.HO_USER
  ) {
    navigate("/dashboardHO");
  } else {
    navigate("/dashboard");
  }
};

export default navigationFaUserAndFaAdmin;
